import $ from 'jquery';

function LoadMoreResults(){
    // selectors
    var resultsSection = $('.results-entrepreneurs');
    var loadMoreButton = resultsSection.find('.loadMoreResults');

    // events
    loadMoreButton.on('click', loadMoreEntrepreneurs);

    // functions
    function loadMoreEntrepreneurs(e){
        $(e.target).prop("disabled", true).html('Chargement <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
        
        var page = e.target.dataset.page;
        var codeNACE = e.target.dataset.code;
        var ville = e.target.dataset.ville;
        // console.log(page + " " + codeNACE + " " + ville);
        $.ajax({
            type: 'POST',
            data: { 
                page : page,
                codeNACE : codeNACE,
                ville : ville,
            },
            url: belgiqueentreprisesData.root_url + '/php/load-more.php',
            success: function(response) {
                // console.log(response);
                $('#queryResultsBox').html(response);
                var oldPage = e.target.dataset.page;
                e.target.dataset.page++;
                $(e.target).prop("disabled", false).html('Voir plus');
                let numberOfRows = resultsSection.find('.row').length;
                // console.log(numberOfRows + " " + 30 * oldPage);
                if(numberOfRows < (30 * oldPage)){
                    $(e.target).css('display', 'none');
                }
            },
            error: (response) => {
                console.log(response);
            },
        });
    }
}

export default LoadMoreResults;